import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'

import APDetail from '../../components/AP/APDetail';
import { fetchVendors, fetchVendorDetail } from '../../actions/vendors_actions';
import { fetchAPInvoices, createAP, editAP, deleteAP, fetchAPDetail, fetchAPCredits, clearCredits, clearAPDetail } from '../../actions/arap_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

const isNumeric = function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

const validate = (values, props) => {
  const errors = {}

  if(values.TotalPayment && !isNumeric(values.TotalPayment)) {
    errors.TotalPayment = 'Accept number only!'
  }

  if(values.TotalPayment <= 0) {
    errors.TotalPayment = 'Positive number only!'
  }

  if(values.Discount && !isNumeric(values.Discount)) {
    errors.Discount = 'Accept number only!'
  }

  if(values.Discount && values.Discount < 0) {
    errors.Discount = 'Positive number only!'
  }

  if(!values.Vendor) {
    errors.Vendor = 'Required'
  }

  if(!values.Account) {
    errors.Account = 'Required'
  }

  if(!values.TotalPayment) {
    errors.TotalPayment = 'Required'
  }

  if(!values.Method) {
    errors.Method = 'Required'
  }

  return errors;
}

const apDetail = reduxForm({
    form: 'apDetail',
    enableReinitialize: true,
    destroyOnUnmount: false,
    touchOnChange: true,
    touchOnBlur: false,
    validate,
})(APDetail);
const selector = formValueSelector('apDetail')

function mapStateToProps(state) {
    const vendor_id = selector(state, 'Vendor');
    const credits = selector(state, 'Credits');

    const invoiceDate = selector(state, 'InvoiceDate');
    const fromDate = selector(state, 'FromDate');
    const toDate = selector(state, 'ToDate');

    const invoiceDateBySequence = selector(state, 'InvoiceDateBySequence');
    const fromDateBySequence = selector(state, 'FromDateBySequence');
    const toDateBySequence = selector(state, 'ToDateBySequence');

    const method = selector(state, 'Method');
    const checkNum = selector(state, 'CheckNum');
    const account = selector(state, 'Account');
    const discount = selector(state, 'Discount');
    const totalPayment = selector(state, 'TotalPayment');
    const waive = selector(state, 'Waive');
    const note = selector(state, 'Note');
    return {
        vendor_id,
        credits,
        invoiceDate,
        fromDate,
        toDate,
        invoiceDateBySequence,
        fromDateBySequence,
        toDateBySequence,
        method,
        checkNum,
        account,
        discount,
        totalPayment,
        waive,
        note,
        invoices: state.arap.invoices,
        invoicesIsLoading: state.arap.invoicesIsLoading,
        invoicesError: state.arap.invoicesError,
        apCreated: state.arap.apCreated,
        apEdited: state.arap.apEdited,
        apCreateError: state.arap.apCreateError,
        apEditError: state.arap.apEditError,
        apIsCreating: state.arap.apIsCreating,
        apIsEditing: state.arap.apIsEditing,
        apDetail: state.arap.apDetail,
        initialValues: state.arap.apDetail,

        credits: state.arap.credits,
        creditsIsLoading: state.arap.creditsIsLoading,
        creditsError: state.arap.creditsError,

        vendors: state.vendors.all,
        vendorsIsLoading: state.vendors.isLoading,
        vendorsError: state.vendors.error,
        currentVendorDetail: state.vendors.currentVendorDetail,
        userPermissions: state.auth.userPermissions,
        checkPassword: state.settings.checkPassword,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,
    }

}


export default connect(mapStateToProps, { fetchAPInvoices, createAP, editAP, deleteAP, fetchVendors, fetchVendorDetail,
  fetchAPDetail, fetchAPCredits, clearCredits, clearAPDetail, checkPassword, clearCheckPassword, setDefaultOfForm })(apDetail)



// WEBPACK FOOTER //
// ./master/jsx/containers/AP/APDetail.jsx